import React from "react";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import { styled } from "styled-components";
import { PrimaryButton } from "./shared/Button";
import { scrollToSection } from "./shared/utils";
import { CTAText } from "./shared/CTAText";

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 70px 5%;

  & .description {
    max-width: 750px;
    margin: 50px auto;
  }

  & .footerText {
    max-width: 700px;
    margin: 30px auto;
    text-align: center;
  }
`;

const Content = styled.div`
  background-image: url("img/background-ai.png");
  text-align: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const BtnWrapper = styled.div`
  padding: 70px;
`;

export const AI = () => {
  return (
    <>
      <Wrapper>
        <Subtitle>
          Te formamos en herramientas de Inteligencia Artificial{" "}
        </Subtitle>
        <Title>
          Este es el mejor momento de la historia para aprender desarrollo de
          software
        </Title>
        <p className="description">
          Los últimos avances en <b>Inteligencia Artifical</b>, lejos de ser una
          amenaza al empleo, son una oportunidad.{" "}
          <b>El futuro es de quien domine la IA. </b>
        </p>
        <p className="description">
          Todo el contenido formativo relativo a IA daría para otro bootcamp,
          pero en Beyond te enseñamos{" "}
          <b>como sacar ventaja de estas herramientas de forma gratuita.</b>
        </p>
        <CTAText>
          Aprenderás a usar <b>Copilot</b> y <b>ChatGPT</b> para escribir código
          más rápido y de mejor calidad
        </CTAText>
      </Wrapper>
      <Content>
        <img style={{ width: "35%" }} src="img/laptop-ai.png" />
        <BtnWrapper>
          <PrimaryButton onClick={() => scrollToSection("contact")}>
            Apúntate clicando aquí 👩‍💻
          </PrimaryButton>
        </BtnWrapper>
      </Content>
      <span id="teachers"></span>
    </>
  );
};
